<svg
  [ngStyle]="styleList"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1.5"
    y="1.5"
    width="61"
    height="61"
    [attr.rx]="rx"
    fill="url(#paint0_linear_1102_1920)"
    stroke="#FEFEFE"
    stroke-width="3"
  />
  <path
    d="M35.8913 49.6366L36.6875 41.6083L15.3813 29.3072L14.4894 38.3017C14.3149 40.0608 15.1865 41.759 16.7174 42.6429L32.1535 51.5549C33.7264 52.463 35.7121 51.4439 35.8913 49.6366Z"
    fill="url(#paint1_linear_1102_1920)"
    stroke="url(#paint2_linear_1102_1920)"
  />
  <path
    d="M47.8111 33.7342L25.5545 20.8843L14.9603 28.4867L37.217 41.3366L47.8111 33.7342Z"
    fill="url(#paint3_linear_1102_1920)"
  />
  <path
    d="M45.495 19.2553L29.2755 9.89098C28.3317 9.34612 27.1403 9.95759 27.0328 11.042L26.0837 20.6125L47.3898 32.9136L48.2181 24.5612C48.4313 22.4113 47.366 20.3356 45.495 19.2553Z"
    fill="url(#paint4_linear_1102_1920)"
    stroke="url(#paint5_linear_1102_1920)"
  />
  <defs>
    <linearGradient
      id="paint0_linear_1102_1920"
      x1="37.5"
      y1="64.0004"
      x2="-64.6232"
      y2="47.3419"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="#EBECF7"
      />
    </linearGradient>
    <linearGradient
      id="paint1_linear_1102_1920"
      x1="28.4154"
      y1="36.2551"
      x2="28.0825"
      y2="53.7393"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint2_linear_1102_1920"
      x1="20.3393"
      y1="36.0774"
      x2="18.0135"
      y2="49.2451"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="white"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
    <linearGradient
      id="paint3_linear_1102_1920"
      x1="24.2877"
      y1="33.9815"
      x2="46.2086"
      y2="12.0605"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop offset="1" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_1102_1920"
      x1="40.2963"
      y1="15.6765"
      x2="39.9633"
      y2="33.1607"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint5_linear_1102_1920"
      x1="31.8491"
      y1="9.7442"
      x2="30.3536"
      y2="21.0168"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="#797979"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
  </defs>
</svg>
